/*jshint esversion: 6 */
import {XhrService} from "../../../../default/global/ts/xhr.service";
import {addActionClass, addErrorClass, addLoadingClass} from "../../../../default/global/js/utilities/updateClasses";
import {appendScriptToDOM} from "../../../../default/global/js/utilities/functions";
import {FetchService} from "../../../../default/global/ts/fetch.service";

function addToFavorites(itemid, beforeSend, successSend, errorSend) {
    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }
    FetchService.get(`/em/item/${itemid}/addToFavorites/`).then(res => {
        if(res.success) {
            if (typeof successSend !== 'undefined') {
                successSend(res);
            }
        } else {
            console.error(res.message);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });
}

function removeFromFavorites(itemid, beforeSend, successSend, errorSend) {
    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }

    FetchService.get(`/em/item/${itemid}/removeFromFavorites/`).then(res => {
        if (res.success) {
            if (typeof successSend !== 'undefined') {
                successSend(res);
            }
        } else {
            console.error(res.message);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });
}

function updateFavoritesCount(currentCount) {
    for (let count of document.querySelectorAll('.js-favoritesCount')) {
        count.innerHTML = currentCount;
        if (parseInt(count.innerHTML) === 0) {
            count.style.display = "none";
        } else {
            addActionClass(count, function () {
                count.style.display = "";
            });
        }
    }
}

function toggleFavoriteBtnClasses(el) {
    let icon = el.querySelector('.icon');
    let filledIconClass = 'icon-bookmark-plus-filled';
    let emptyIconClass = 'icon-bookmark-plus';
    if (el.classList.contains("js-addToFavorites")) {
        el.classList.remove("js-addToFavorites");
        el.classList.add("js-removeFromFavorites");

        if (icon) {
            icon.classList.remove(emptyIconClass);
            icon.classList.add(filledIconClass);
        }
    } else {
        el.classList.remove("js-removeFromFavorites");
        el.classList.add("js-addToFavorites");

        if (icon) {
            icon.classList.remove(filledIconClass);
            icon.classList.add(emptyIconClass);
        }
    }
}

export function triggerFavoritesBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addToFavorites")) {
            let itemID = target.dataset.id;
            if (itemID) {
                if (document.body.classList.contains("favorites")) {
                    addLoadingClass(target);
                    window.location.href = "?action=shop_add_item_to_favorites&action_id=" + itemID;
                }else{
                    addToFavorites(itemID, () => {

                    }, (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(target);
                            updateFavoritesCount(result.data.currFavoriteCount);

                            if (result.data.includeTagMgr) {
                                XhrService.generalAjaxCall('add_item_to_favorite').then(tmResult => {
                                    if (tmResult.tagManager) {
                                        appendScriptToDOM(tmResult.tagManager, true);
                                    }
                                });
                            }
                        } else {
                            addErrorClass(target);
                        }
                    }, () => {
                        addErrorClass(target);
                    });
                }
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromFavorites")) {
            const itemID = target.dataset.id;
            if (itemID) {
                if (document.body.classList.contains("favorites")) {
                    addLoadingClass(target);
                    window.location.href = "?action=shop_remove_item_from_favorites&action_id=" + itemID;
                } else {
                    removeFromFavorites(itemID, () => {

                    }, (result) => {
                        if (result.success) {
                            toggleFavoriteBtnClasses(target);
                            updateFavoritesCount(result.data.currFavoriteCount);
                            if (result.tagManager) { // TODO move to seperate ajax call
                                appendScriptToDOM(result.tagManager, true);
                            }
                        } else {
                            addErrorClass(target);
                        }
                    }, () => {
                        addErrorClass(target);
                    });
                }
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }
    });
}